// extracted by mini-css-extract-plugin
export default {"container":"hom_1hsbD","blocks":"hom_blo_6MY1n"};